import { useState, useCallback } from 'preact/hooks';

const STORAGE_KEY = 'voice-assistant-session-sound';

function loadMap(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const o = JSON.parse(raw) as Record<string, unknown>;
    if (!o || typeof o !== 'object') return {};
    const out: Record<string, boolean> = {};
    for (const [k, v] of Object.entries(o)) {
      if (typeof v === 'boolean') out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

function persistMap(m: Record<string, boolean>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(m));
  } catch { /* ignore */ }
}

/** Per-tab chat sound preference (default ON). Master switch is separate (drawer). */
export function useSessionSound() {
  const [map, setMap] = useState<Record<string, boolean>>(loadMap);

  const isSessionSoundOn = useCallback(
    (sessionId: string | null | undefined) => {
      if (!sessionId) return true;
      return map[sessionId] !== false;
    },
    [map],
  );

  const toggleSessionSound = useCallback((sessionId: string | null | undefined) => {
    if (!sessionId) return;
    setMap((prev) => {
      const wasOn = prev[sessionId] !== false;
      const next = { ...prev };
      if (wasOn) next[sessionId] = false;
      else delete next[sessionId];
      persistMap(next);
      return next;
    });
  }, []);

  return { isSessionSoundOn, toggleSessionSound, sessionSoundMap: map };
}
